<template>
    <b-table stacked="md" :items="results" :fields="resultFields" :sortBy="sortBy" :sortDesc="sortDesc" striped small>
        <template v-slot:table-caption>
            <div>*WSSA Recognized (non-sanctioned)</div>
            <div>Note: Competitions prior to {{firstDayOfNewRelayRules.toLocaleDateString()}} used old rules for relay. The times set using old rules are grayed.</div>
            <div>Note: Starting {{firstDayOfGen5.toLocaleDateString()}} the WSSA switched to G5 timers. All times/records set prior to that date were archived.</div>
        </template>
        <template v-slot:cell(name)="data">
            <b-link v-if="data.item.wssaLink" :href="data.item.wssaLink">{{data.item.name}}</b-link>
            <span v-else>{{data.item.name}}</span>
        </template>
        <template v-slot:cell(finalsRelay)="data">
            <span :class="{ oldRules: data.item.date < firstDayOfNewRelayRules }">{{formatTime(data.item.finalsRelay, null, data.item)}}</span>
        </template>
    </b-table>
</template>

<script>
import { formatTimeBasedOnDate, firstDayOfNewRelayRules, firstDayOfGen5 } from '@/common/times';

export default {
    data() {
        return {
            sortBy: "date",
            sortDesc: true,
            firstDayOfNewRelayRules: firstDayOfNewRelayRules,
            firstDayOfGen5: firstDayOfGen5,
            resultFields: [{
                key: "name",
                sortable: true
            }, {
                key: "date",
                sortable: true,
                formatter: "formatDate"
            }, {
                key: "location",
                sortable: true
            }, {
                key: "finals333",
                label: "3-3-3",
                sortable: true,
                formatter: "formatTime"
            }, {
                key: "finals363",
                label: "3-6-3",
                sortable: true,
                formatter: "formatTime"
            }, {
                key: "finalsCycle",
                label: "Cycle",
                sortable: true,
                formatter: "formatTime"
            }, {
                key: "finalsCombined",
                label: "Combined",
                sortable: true,
                formatter: "formatTime"
            }, {
                key: "finalsDoubles",
                label: "Doubles",
                sortable: true,
                formatter: "formatTime"
            }, {
                key: "finalsRelay",
                label: "Relay",
                sortable: true
            }],
        };
    },
    props: ["results"],
    methods: {
        formatDate(value, key, item) {
            if (!item.length || item.length === 1)
                return value.toLocaleDateString()
            const startDate = value.toLocaleDateString();
            var endDate = new Date(value.valueOf());
            endDate.setDate(endDate.getDate() + item.length - 1);
            endDate = endDate.toLocaleDateString();
            return startDate + " to " + endDate;
        },
        formatTime(value, key, item) {
            return formatTimeBasedOnDate(value, item);
        }
    }
}
</script>

<style scoped>
    .oldRules {
        color: gray;
    }
</style>